import { Textarea } from '@creditornot/cb-input';
import React from 'react';
import { Field } from 'react-final-form';
import { useIntl } from 'react-intl';
import styled from 'styled-components';

import { SurveyQuestion } from 'apis/merchant-gateway/nps/types';
import { Typography } from 'common/typography';

import { useSurveyIntl } from './SurveyLocaleContext';

type OpenEndedQuestionProps = {
  question: SurveyQuestion;
  pageIdx: number;
  questionIdx: number;
};

const QuestionHeading = styled(Typography.Body3)`
  display: block;
  margin-block-end: 14px;
`;

const OpenEndedQuestion = ({ question, pageIdx, questionIdx }: OpenEndedQuestionProps) => {
  const intl = useIntl();
  const { formatSurveyMessage } = useSurveyIntl();

  return (
    <>
      <QuestionHeading>
        {formatSurveyMessage({ fallback: question.headings[0].heading, resourceId: question.id })}
      </QuestionHeading>
      <Field name={`pages.${pageIdx}.questions.${questionIdx}.answers.0.text`} type="textarea">
        {({ input }) => (
          <Textarea {...input} placeholder={intl.formatMessage({ id: 'nps.questionnaire.add-feedback' })} />
        )}
      </Field>
    </>
  );
};

export default OpenEndedQuestion;
